module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/nusajaya.gif?v=0cfdca1c";